import * as api from "@/api/williams/welders";
import { UseFormReturn } from "react-hook-form";
import { Welder } from "@/api/williams/welders";

export function useWelderValidation(form: UseFormReturn<Welder>) {
  return async function validate(welder: Welder) {
    const result = await api.validateWelder({
      ...welder,
      badgeNumber: welder.lastName + welder.ssn,
    });

    if (!result.isWelderUnique) {
      form.setError("root", { message: "Welder already exists" });
    }

    return result.isWelderUnique;
  };
}
